"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicAcceptFlow = void 0;
var react_1 = __importStar(require("react"));
var AcceptFlowComponent_1 = require("@CommonFrontend/AcceptFlow/AcceptFlowComponent");
var UseOnSubmitForm_1 = require("./UseOnSubmitForm");
var inversify_react_1 = require("inversify-react");
var PostAcceptRedirect_1 = require("../AcceptFlowV2/PostAcceptRedirect");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var pages_common_1 = require("@qwilr/pages-common");
var AuthenticationContext_1 = require("@CommonFrontend/Public/Identity/AuthenticationContext");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var PublicAcceptFlow = function (_a) {
    var _b;
    var onClose = _a.onClose, accepters = _a.accepters, $timeout = _a.$timeout, settings = _a.settings, autofillEnabled = _a.autofillEnabled, isSimpleMode = _a.isSimpleMode, autoScrollIntoView = _a.autoScrollIntoView, requiresQuoteChoice = _a.requiresQuoteChoice;
    var isPrintMode = (0, inversify_react_1.useInjection)("isPrintMode");
    var publicApiBaseUrl = (0, inversify_react_1.useInjection)("publicApiBaseUrl");
    var projectCreatorProfile = (0, inversify_react_1.useInjection)("projectCreatorProfile");
    var isStripeIntegrationEnabled = (0, inversify_react_1.useInjection)("isStripeIntegrationEnabled");
    var stripePublicKey = (0, inversify_react_1.useInjection)("stripePublicKey");
    var stripeUserId = (0, inversify_react_1.useOptionalInjection)("stripeUserId");
    var visitToken = (_b = (0, inversify_react_1.useInjection)("visitToken")) !== null && _b !== void 0 ? _b : "";
    var authAppBaseUrl = (0, inversify_react_1.useInjection)("authAppBaseUrl");
    var _c = __read((0, react_1.useState)(undefined), 2), auditTrailPdfUrl = _c[0], setAuditTrailPdfUrl = _c[1];
    var springboardAppBaseUrl = (0, inversify_react_1.useInjection)("springboardAppBaseUrl");
    var consumerDataServiceBaseUrl = (0, inversify_react_1.useInjection)("consumerDataServiceBaseUrl");
    var secretHash = (0, inversify_react_1.useInjection)("secretHash");
    var usingFeature = (0, inversify_react_1.useInjection)("usingFeature");
    var optOutSpringboard = usingFeature(FeatureFlag_1.default.OptOutSpringboardEngagementMenu);
    var telemetry = (0, inversify_react_1.useInjection)("acceptTelemetry");
    var isCollaboratorPage = (0, inversify_react_1.useInjection)("isCollaboratorPage");
    var isTemplate = (0, inversify_react_1.useInjection)("isTemplate");
    var onSubmitAccepter = (0, UseOnSubmitForm_1.useOnSubmitForm)(accepters, $timeout, setAuditTrailPdfUrl);
    var addPaymentUrl = "".concat(publicApiBaseUrl, "/projects/").concat(projectCreatorProfile.secret, "/add-payment");
    var checkPaymentUrl = "".concat(publicApiBaseUrl, "/projects/").concat(projectCreatorProfile.secret, "/check-payment");
    var projectApiUrl = "".concat(publicApiBaseUrl, "/projects/").concat(projectCreatorProfile.secret);
    var paymentApiUrls = {
        checkPaymentUrl: "".concat(projectApiUrl, "/check-payment"),
        createSetupIntentUrl: "".concat(projectApiUrl, "/payment/setup-intent"),
        addPaymentV2Url: "".concat(projectApiUrl, "/payment"),
    };
    return (react_1.default.createElement(AuthenticationContext_1.AuthenticationContextProvider, { authAppBaseUrl: authAppBaseUrl },
        react_1.default.createElement(AuthenticationProvider, null,
            react_1.default.createElement(pages_common_1.SpringboardContextProvider, { authAppBaseUrl: authAppBaseUrl, springboardAppBaseUrl: springboardAppBaseUrl, consumerDataServiceUrl: consumerDataServiceBaseUrl, pageHash: secretHash },
                react_1.default.createElement(AcceptFlowComponent_1.AcceptFlow, { onClose: onClose, onSubmitForm: onSubmitAccepter, settings: settings, autofillEnabled: autofillEnabled, isPreviewAccept: false, isStripeIntegrationEnabled: isStripeIntegrationEnabled, stripePublicKey: stripePublicKey, stripeUserId: stripeUserId, addPaymentUrl: addPaymentUrl, checkPaymentUrl: checkPaymentUrl, optOutSpringboard: optOutSpringboard, postAcceptRedirectUrl: (0, PostAcceptRedirect_1.getPostAcceptanceRedirectUrl)(projectCreatorProfile, visitToken), auditTrailPdfUrl: auditTrailPdfUrl, isPrintMode: isPrintMode, consumerDataServiceUrl: consumerDataServiceBaseUrl, telemetry: telemetry, isCollaboratorPage: isCollaboratorPage, isTemplateGallery: isTemplate, isSimpleMode: isSimpleMode, accepters: accepters, autoScrollIntoView: autoScrollIntoView, requiresQuoteChoice: requiresQuoteChoice(), paymentApiUrls: paymentApiUrls })))));
};
exports.PublicAcceptFlow = PublicAcceptFlow;
var AuthenticationProvider = function (_a) {
    var children = _a.children;
    var usingFeature = (0, inversify_react_1.useInjection)("usingFeature");
    var isPrintMode = (0, inversify_react_1.useInjection)("isPrintMode");
    var skipClerkCheck = usingFeature(FeatureFlag_1.default.DisableClerkOnPublicPages) || isPrintMode;
    var _b = __read((0, react_1.useState)(!skipClerkCheck), 2), waitingForClerk = _b[0], setWaitingForClerk = _b[1];
    var _c = __read((0, react_1.useState)(false), 2), isClerkInitialised = _c[0], setIsClerkInitialised = _c[1];
    var _d = __read((0, react_1.useState)(0), 2), checkCount = _d[0], setCheckCount = _d[1];
    var maxCheck = 20;
    var intervalRef = (0, react_1.useRef)();
    var stopChecking = function () {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
        }
        setWaitingForClerk(false);
    };
    if (!skipClerkCheck) {
        intervalRef.current = setInterval(function () {
            if (checkCount < maxCheck) {
                if (window.Clerk !== undefined && window.Clerk.isReady()) {
                    setIsClerkInitialised(true);
                    stopChecking();
                }
                else {
                    setCheckCount(checkCount + 1);
                }
            }
            else {
                stopChecking();
            }
        }, 500);
    }
    if (waitingForClerk) {
        return (react_1.default.createElement(kaleidoscope_1.Stack, null,
            react_1.default.createElement(kaleidoscope_1.Spinner, null)));
    }
    if (isClerkInitialised) {
        return react_1.default.createElement(pages_common_1.ClientOnlyAuthenticationContextProvider, null, children);
    }
    return (react_1.default.createElement(pages_common_1.AuthenticationContextProvider, { isSignedIn: false, isInitialized: true, signOut: function () { return Promise.resolve(); }, getToken: function () { return Promise.resolve(""); } }, children));
};
